export const SET_BOUNDS = 'SET_BOUNDS'
export const SET_ZOOM = 'SET_ZOOM'
export const SET_MODE = 'SET_MODE'
export const SET_ACTIVE_FEATURE = 'SET_ACTIVE_FEATURE'

export const setBounds = bounds => ({
    type: SET_BOUNDS,
    bounds
})

export const setZoom = zoom => ({
    type: SET_ZOOM,
    zoom
})

export const setMode = mode => ({
    type: SET_MODE,
    mode
})

export const setActiveFeature = feature => ({
    type: SET_ACTIVE_FEATURE,
    feature
})
